
import React from 'react';
import { Layout } from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Home: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <Layout>
      <div className="container mx-auto py-12">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Willkommen zur Hoss-Immo Administration</h1>
          <p className="text-xl mb-8">Verwalten Sie Ihre Immobilienmarketing-Kampagnen an einem Ort</p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              onClick={() => navigate('/dashboard')}
              className="bg-blue-600 hover:bg-blue-700"
            >
              Zum Dashboard
            </Button>
            
            <Button
              size="lg"
              variant="outline"
              onClick={() => navigate('/login')}
            >
              Anmelden
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Home;
